import { cn } from './ui';

interface LogoProps {
  className?: string;
}

/**
 * Круглая печать школы — та же, что на баннере и на аватарке в мессенджерах.
 *
 * Растр, а не контурная иконка из `MotoIcons`: в печати есть закатный градиент
 * и штриховка по кольцу, в одну линию это не пересказать. Файл один на все
 * места — 192px хватает на тройную плотность при показе до 64px, а крупнее
 * печать в интерфейсе нигде не стоит.
 *
 * Печать всегда идёт рядом с названием школы, поэтому для скринридера она
 * пустая: иначе имя школы прочитается дважды подряд.
 */
export function Logo({ className }: LogoProps): React.JSX.Element {
  return (
    <img
      src="/logo-192.png"
      alt=""
      width={192}
      height={192}
      decoding="async"
      className={cn('shrink-0 object-contain', className)}
    />
  );
}
